import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarClientes, filtrarClientes } from '../../../actions/clientes';

import FiltrosCliente from './FiltrosCliente';

const Clientes = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Clientes',
            path: '/ingresos/clientes'
        }
    ];

    const dispatch =  useDispatch();

    const { usuario } = useSelector(state => state.auth);
    const { listado } = useSelector(state => state.clientes);

    const [clientes, setClientes] = useState([]);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            selector: row => row.nombre, 
            grow: 1.5,
        },
        {
            name: 'Apellido',
            selector: row => row.apellido, 
            grow: 1.5
        },
        {
            name: 'Correo',
            selector: row => row.correo,
            grow: 2
        },
        {
            name: 'Teléfono(s)',
            selector: row => row.telefono ? row.telefono + (row.celular ? ', ' + row.telefono : '') : row.celular, 
            grow: 2
        },
        {
            name: '',
            cell: row => {
                return(
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.clientes?.perfil &&
                                <Link className="btn btn-sm btn-link px-2 float-end" to={`/ingresos/clientes/perfil/${row.id}`}><i className="fas fa-eye text-info"></i></Link>
                        }
                    </div>
                )
            }
        }
    ];

    /* Filtros de busqueda */
    const handleFiltrosBusqueda = () => {
        dispatch(filtrarClientes(true));
    }

    useEffect(() => {
        dispatch(buscarClientes({
            nombre: null
        }));
    }, []);

    useEffect(() => {
        setClientes(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <FiltrosCliente />

            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-3 mt-5">Clientes</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-secondary mx-1" onClick={() => handleFiltrosBusqueda()}>Filtros de búsqueda</button>
                    </div>

                    <div className="mt-3">
                        <DataTable 
                            columns={columns}
                            data={clientes}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Clientes;